<template>
  <div>
    <page-heading-info
    title="Jefferson County GIS"
    ></page-heading-info>

    <text-box-title title="GIS Updates">
      <div class="col mt-3">
        The county GIS system is currently being updated. Please check back at a later time.
      </div>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
  },
  data () {
    return {}
  }
}
</script>

<style>

</style>

